import buildSubjectApiPath from '@Application/Subjects/buildSubjectApiPath';
import type * as React from 'react';
import transcriptTurnsFetched, {
	type TranscriptTurnsFetchedAction,
	type TranscriptTurnsFetchedPayload,
} from '@Application/Beneficiaries/Transcripts/Actions/transcriptTurnsFetched';
import transcriptTurnsFetchFailed, {
	type TranscriptTurnsFetchFailedAction,
} from '@Application/Beneficiaries/Transcripts/Actions/transcriptTurnsFetchFailed';
import type FetchTranscriptTurns from '@Application/Beneficiaries/Transcripts/Queries/FetchTranscriptTurns';
import { get } from '@Domain/Api';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';

type Actions = TranscriptTurnsFetchedAction | TranscriptTurnsFetchFailedAction;

export default (query: FetchTranscriptTurns) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			// Server-side pagination: `get` is used deliberately, never `getPaginated` (which walks
			// every page and would reassemble the entire transcript in the browser).
			const baseUrl = `${buildSubjectApiPath(query.facilityId, query.subject)}/interviews/${query.interviewId}/transcript/turns`;

			const payload = await get<TranscriptTurnsFetchedPayload>(`${baseUrl}?${query.toQueryString()}`);

			const action = transcriptTurnsFetched(payload, query.interviewId, query.page);
			dispatch(action);
			return action;
		} catch (error) {
			const action = transcriptTurnsFetchFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
